import { inject } from 'vue';

export const useToast = () => {
  const toast = inject('ToastMessageService');

  if (!toast) throw new Error('Vue Toastification is not provided');

  return toast;
};
